import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';
import { firstValueFrom } from 'rxjs';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { AppConsts } from '../../AppConsts';
import { ServiceDto, ServicePagedRequestDto, ServiceService } from 'src/app/proxy/services';

@Component({
  selector: 'app-service-autocomplete',
  standalone: false,
  templateUrl: './service-autocomplete.component.html',
})
export class ServiceAutocompleteComponent extends AppBaseComponent implements OnInit {
  @Input() isRequired: boolean;
  @Input()
  set service(value: ServiceDto | undefined) {
    this.selectedService = value;
    if (value) {
      this.selectedServiceId = value.id;
      this.setServiceSelectedIfCorrespond();
    }
  }
  
  @Output() changeSelectedService = new EventEmitter<ServiceDto>();

  services: ServiceDto[];
  selectedService: ServiceDto;

  private selectedServiceId: number;
  
  constructor(
    injector: Injector,
    private readonly _serviceService: ServiceService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.loadServices();
    this.onChangeSelectedService();
  }

  async loadServices(filter: AutoCompleteCompleteEvent = undefined): Promise<void> {
    try {
      this.showLoading();

      const inputDto: ServicePagedRequestDto = {
        name: filter?.query,
        maxResultCount: AppConsts.MaxPageSize,
        skipCount: 0,
        vendorId: undefined,
        externalSystemIds: undefined
      };

      this.services = (await firstValueFrom(this._serviceService.getAllByInput(inputDto)))?.items || [];
      this.setServiceSelectedIfCorrespond();
    } finally {
      this.hideLoading();
    }
  }

  onChangeSelectedService(): void {
    this.changeSelectedService.emit(this.selectedService);
  }

  setSelectedServiceId(serviceId: number): void {
    this.selectedServiceId = serviceId;
    if (this.services && this.services.length > 0) {
      this.selectedService = this.services.find(service => service.id === serviceId);
    }
  }

  private setServiceSelectedIfCorrespond(): void {
    if (this.selectedServiceId) {
      this.selectedService = this.services.find(service => service.id === this.selectedServiceId);
    }
  }
}